import APIClass = require("./app/app"); // for type-safety only!
import globals = require("./globals");

/**
 * IE11 polyfills
 */
{
  (function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty("remove")) {
        return;
      }
      Object.defineProperty(item, "remove", {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          this.parentNode.removeChild(this);
        },
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
}

function log(...args: any[]) {
  false && console.log.call(console, args);
}

// query string parameters override global defaults
let paths = globals.paths();

// ["app", "cdn", "proxy", "services", "map", "test"]
Object.keys(globals)
  .filter((k) => !!paths[k])
  .forEach((key) => {
    log("updating global", key);
    globals[key] = paths[key];
  });
Object.keys(globals).forEach((key) => {
  log(`globals[${key}]=`, globals[key]);
});

// where is the application server?
globals.app = globals.app || "//" + location.host + location.pathname.substring(0, location.pathname.lastIndexOf("/"));

// where is the content distribution network (CDN)?
let baseUrl = globals.cdn || "//" + location.host;

// where is the application?
let api = globals["api"] || "app/app";

let debug = "1" === globals.debug;
let localhost = window.location.hostname === "localhost";

function callback() {
  log("AMD loaded");

  // load the app with state
  let appId = paths["map"];

  if (appId) {
    requirejs([api], (API: typeof APIClass) => {
      log("API loaded");
      API.create({ parentId: appId }).done(() => log("API ready to use"));
    });
    return;
  }

  let test = paths["test"];
  // run these unit tests
  if (test) {
    // must load after requirejs.config so require it here
    requirejs(["app/test/test"], (TestRunner) => TestRunner.run(test));
    return;
  }
}

// configure requirejs
requirejs.config({
  baseUrl: baseUrl, //'//192.168.1.53:93',
  map: {
    "*": {
      openlayers: "ol",
    },
  },
  shim: {},
  packages: [
    "main",
    {
      name: "mocha",
      location: "mocha",
      main: "mocha",
    },
    {
      name: "chai",
      location: `chai`,
      main: "chai",
    },
    {
      name: "power-assert",
      location: `power-assert/build`,
      main: "power-assert",
    },
    {
      name: "should",
      location: "should",
      main: "should",
    },
    {
      name: "proj4",
      location: "../static/proj4",
      main: "dist/proj4",
    },
    {
      name: "ol",
      location: "../static/ol",
      main: "ol",
    },
    {
      name: "ol-css",
      location: "../static/ol",
      main: "ol.css",
    },
    {
      name: "xstyle",
      location: "../static/xstyle",
    },
    {
      name: "jquery",
      location: "jquery/dist",
      main: "jquery.min",
    },
    {
      name: "sizzle",
      location: "sizzle/dist",
      main: "sizzle.min",
    },
    {
      name: "underscore",
      location: "underscore",
      main: "underscore-min",
    },
    {
      name: "backbone",
      location: "backbone",
      main: "backbone-min",
    },
    {
      name: "backbone.marionette",
      location: "backbone.marionette/lib",
      main: "backbone.marionette.min",
    },
    {
      name: "app",
      location: `${globals.app}/built`,
    },
  ],
  deps: [],
  waitSeconds: 30, // ol.debug fails to load sometimes
  callback: callback,
});
